<template>
  <div>
    <div>
      <PageHeaderLayout>
        <div class='main-page-content'>
          <div class='theme-border p-10'>
            <div class='p-10 flex-sb'>
              <div>
                <el-link type='primary' @click='getList'>
                  <span :class='[loading?"el-icon-loading":"el-icon-refresh"]'></span> 刷新
                </el-link>
              </div>
              <div>
                <span>OA审批设置：①基础设置 ②表单设计 ③流程设计</span>
              </div>
              <div>
                <el-tooltip content="①②请到审批模板页面进行设置，一般是初始使用新模板的时候初始化1次即可，后续若有调整，则更新即可" placement="top">
                  <el-button type='primary' @click='handleTplPage' title='（①②请到审批模板页面进行设置，一般是初始使用新模板的时候初始化1次即可，后续若有调整，则更新即可）'>
                    ①②审批模板
                  </el-button>
                </el-tooltip>

                <el-button type='primary' @click='handleOldPage'>
                  回到旧版
                </el-button>
              </div>
            </div>
            <div style='width:clamp(500px, 50vw, 1080px)' class='p-10'>
              <el-table :data='dataList' highlight-current-row border>
                <el-table-column label='序号' type='index' align='center' width='50'></el-table-column>
                <el-table-column label='模板名称' align='center' prop='description'></el-table-column>
                <el-table-column label='操作' align='center' width='140'>
                  <template slot-scope='{ row }'>
                    <div class='flex-evenly'>
                      <el-link type='primary' @click='openToWorkFlow(row)'>流程设计<i
                        class='el-icon-edit-outline'></i>
                      </el-link>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </PageHeaderLayout>
    </div>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'

export default {
  name: 'OaSettingIndex',
  components: { PageHeaderLayout },
  data() {
    return {
      dataList: [],
      loading: false
    }
  },
  methods: {
    async getList() {
      this.loading = true
      const { list } = await this.$api.oaTemplateList()
      this.dataList = list || []
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    //跳转到工作流设计
    openToWorkFlow(row) {
      this.$router.push({ name: 'workflow', params: { workFlowDefId: row.id } })
    },
    handleTplPage(){
      this.$router.push({ name: 'oaTemplateManage' })
    },
    handleOldPage(){
      this.$router.push({ name: 'oldOASetting' })
    }
  },
  mounted() {
    this.getList()
  }
}
</script>

